


































import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    PropType,
    watch,
    onMounted,
} from '@vue/composition-api';
import { ChangeEmailSteps } from './const';
import StepInfo from '@/views/register/components/step-info.vue';
import StepEmail from '@/views/register/components/step-email.vue';
import {
    handleSuccessMessageToast,
    handleErrorMessageToast,
} from '@/common/util';

export default defineComponent({
    name: 'change-email',
    components: {
        StepInfo,
        StepEmail,
    },
    setup(props, context) {
        const state = reactive({
            stepActive: 0,
            reFillInfo: {},
            bindInfo: {},
        });
        function getStepIndex(stepIndex: number) {
            if (stepIndex === 2) {
                handleSuccessMessageToast('修改成功');
                context.root.$router.push({
                    path: '/platform/profile/user',
                });
            }
            state.stepActive = stepIndex;
        }
        function getbindInfo(bindInfo: object) {
            state.bindInfo = bindInfo;
        }
        function cancelChange() {
            context.root.$router.push({
                path: '/platform/profile/user',
            });
        }
        return {
            ...toRefs(state),
            getStepIndex,
            getbindInfo,
            cancelChange,
            changeEmailSteps: ChangeEmailSteps,
        };
    },
});
